var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        color: "primary",
        icon: "business",
        "store-modal": "",
        title: _vm.generateMessage(
          `heatingSetupParams.${_vm.isEditing ? "update" : "create"}.title`
        )
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _vm.isEditing
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mx-2 text-validate-btn",
                          attrs: {
                            small: "",
                            color: "warning",
                            loading: _vm.isLoading
                          },
                          on: {
                            click: function($event) {
                              _vm.confirmDeleteDialog = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.generateMessage(
                                  "requests.actions.delete_param"
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "mx-2 text-validate-btn",
                          attrs: {
                            small: "",
                            color: "primary",
                            loading: _vm.isLoading,
                            disabled: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.generateMessage(
                                  "requests.actions.delete_param"
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.isEditing
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mx-2 text-validate-btn",
                          attrs: {
                            small: "",
                            color: "primary",
                            loading: _vm.isLoading,
                            disabled:
                              _vm.requiredComment &&
                              !(
                                _vm.param.agency_entity_comment &&
                                _vm.param.agency_entity_comment.length > 10
                              )
                          },
                          on: { click: _vm.update }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.generateMessage("requests.actions.validate")
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "mx-2 text-validate-btn",
                          attrs: {
                            small: "",
                            color: "primary",
                            loading: _vm.isLoading,
                            disabled:
                              !_vm.validTNC ||
                              !_vm.param.activation_type ||
                              (_vm.requiredComment &&
                                !(
                                  _vm.param.agency_entity_comment &&
                                  _vm.param.agency_entity_comment.length > 10
                                ))
                          },
                          on: { click: _vm.create }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.generateMessage("requests.actions.validate")
                              ) +
                              "\n      "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { small: "" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.cancel")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "400" },
                  model: {
                    value: _vm.confirmDeleteDialog,
                    callback: function($$v) {
                      _vm.confirmDeleteDialog = $$v
                    },
                    expression: "confirmDeleteDialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v("Confirmer la suppression")
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n          Êtes-vous sûr de vouloir supprimer ce paramétrage ?\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "grey", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.confirmDeleteDialog = false
                                }
                              }
                            },
                            [_vm._v("\n            Annuler\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "warning", text: "" },
                              on: { click: _vm.handleDelete }
                            },
                            [_vm._v("Supprimer")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-simple-table",
        {
          staticClass: "secondarybackground",
          class: {
            "non-editable-table-dark": _vm.darkThemeEnabled,
            "non-editable-table-light": !_vm.darkThemeEnabled
          },
          attrs: { id: "non-editable-table" }
        },
        [
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Numéro d'installation\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n          " + _vm._s(_vm.item.code) + "\n        ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Adresse\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(_vm.item.street) + " - " + _vm._s(_vm.item.city))
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Nom\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n          " + _vm._s(_vm.item.name) + "\n        ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Equipe\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " + _vm._s(_vm.item.entity_id) + "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Type de marché\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " + _vm._s(_vm.item.market_type) + "\n        "
                )
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Usage\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n          " + _vm._s(_vm.item.purpose) + "\n        ")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Responsable Maintenance\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _vm._v(_vm._s(_vm.item.mnt_responsible_technician))
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.item.mnt_responsible_phone))])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Binôme\n        ")
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", [_vm._v(_vm._s(_vm.item.mnt_resp_buddy))]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.item.mnt_resp_buddy_phone))])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Pré-Allumage\n        ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("custom-color-chip", {
                    attrs: { value: _vm.item.valid_visit }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "font-weight-bold" }, [
                _vm._v("\n          Présence ECS\n        ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("custom-color-chip", {
                    attrs: { value: _vm.item.ECS_existence }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "text-center pa-0 mb-4", attrs: { cols: "12" } },
                [_c("h3", [_vm._v("Automates")])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "loader",
            { attrs: { "is-loading": _vm.isLoadingController } },
            [
              _vm.controllers && _vm.controllers.length
                ? _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      dense: "",
                      headers: _vm.cHeaders,
                      items: _vm.controllers,
                      "items-per-page": 100,
                      height: "97",
                      "hide-default-footer": "",
                      "fixed-header": "",
                      "sort-by": ["communication_status"]
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.communication_status",
                          fn: function({ item }) {
                            return [
                              _c("custom-color-chip", {
                                attrs: { value: item.communication_status }
                              })
                            ]
                          }
                        },
                        {
                          key: "item.date_last_communication",
                          fn: function({ item }) {
                            return [
                              item.date_last_communication
                                ? _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          new Date(
                                            item.date_last_communication
                                          ).toLocaleDateString()
                                        ) +
                                        "\n            " +
                                        _vm._s(
                                          new Date(
                                            item.date_last_communication
                                          ).toLocaleTimeString()
                                        ) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      701409927
                    )
                  })
                : _c("div", { staticClass: "caption font-italic" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage(
                            "heatingSetupParams.fields.controllers"
                          )
                        ) +
                        "\n      "
                    )
                  ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-simple-table",
        { staticClass: "secondarybackground", attrs: { id: "editable-table" } },
        [
          _vm.isEditing
            ? _c("v-icon", { attrs: { medium: "", color: "primary" } }, [
                _vm._v("edit")
              ])
            : _c("v-icon", { attrs: { medium: "", color: "primary" } }, [
                _vm._v("mdi-plus")
              ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "font-italic" }, [
                _vm._v("\n          PEM/Bâtisseur\n        ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("custom-color-chip", {
                    attrs: { editable: "" },
                    model: {
                      value: _vm.param.PEM_action_validation,
                      callback: function($$v) {
                        _vm.$set(_vm.param, "PEM_action_validation", $$v)
                      },
                      expression: "param.PEM_action_validation"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("td"),
              _vm._v(" "),
              _c("td")
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "font-italic" }, [
                _vm._v("\n          Allumage à distance\n        ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("custom-color-chip", {
                    attrs: { editable: "" },
                    model: {
                      value: _vm.param.REE_activation_validation,
                      callback: function($$v) {
                        _vm.$set(_vm.param, "REE_activation_validation", $$v)
                      },
                      expression: "param.REE_activation_validation"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "font-italic" }, [
                _vm._v("\n          Arrêt à distance\n        ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("custom-color-chip", {
                    attrs: { editable: "" },
                    model: {
                      value: _vm.param.REE_stop_validation,
                      callback: function($$v) {
                        _vm.$set(_vm.param, "REE_stop_validation", $$v)
                      },
                      expression: "param.REE_stop_validation"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "font-italic" }, [
                _vm._v("\n          Mode *\n        ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.param.activation_type,
                        callback: function($$v) {
                          _vm.$set(_vm.param, "activation_type", $$v)
                        },
                        expression: "param.activation_type"
                      }
                    },
                    _vm._l(["PEM", "Technicien", "Autonome"], function(item) {
                      return _c("v-radio", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "font-italic" }, [
                _vm._v(
                  "\n          Commentaire\n          " +
                    _vm._s(_vm.requiredComment ? " *" : "") +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("v-textarea", {
                    attrs: {
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      placeholder: _vm.requiredComment
                        ? "Un commentaire doit être renseigné en cas de refus (10 caractères minimum)."
                        : ""
                    },
                    model: {
                      value: _vm.param.agency_entity_comment,
                      callback: function($$v) {
                        _vm.$set(_vm.param, "agency_entity_comment", $$v)
                      },
                      expression: "param.agency_entity_comment"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }